import { render } from "./DevDebugDataBlock.vue?vue&type=template&id=64b330a0&scoped=true"
import script from "./DevDebugDataBlock.vue?vue&type=script&lang=js"
export * from "./DevDebugDataBlock.vue?vue&type=script&lang=js"

import "./DevDebugDataBlock.vue?vue&type=style&index=0&id=64b330a0&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2326401477/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64b330a0"]])

export default __exports__